<a *ngIf="photoCount > 0 && orderId"
   class="order-photo-count-link"
   [bcmRouterLink]="['orders', orderId]"
   [queryParams]="{ tab: 'attachments' }"
   [matTooltip]="'boats.orders.showPhotos' | translate"
   [attr.aria-label]="'boats.orders.showPhotos' | translate"
   (click)="onClick($event)">
    <span class="order-photo-count-link__icon-wrap">
        <mat-icon class="order-photo-count-link__icon">image</mat-icon>
        <span class="order-photo-count-link__badge">{{ photoCount }}</span>
    </span>
</a>
